module.exports = __webpack_public_path__ + "img/btn.7450afac.png";